export default "__VITE_ASSET__5526084e__"